export default class RadioStatusConstants {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const NO_CONFIRMED = new RadioStatusConstants(false, 'no_confirmed', '未确认')
export const CONFIRMED = new RadioStatusConstants(true, 'confirmed', '已确认')
export const SHOW = new RadioStatusConstants(true, 'show', '显示')
export const NO_SHOW = new RadioStatusConstants(false, 'no_show', '不显示')
export const YES = new RadioStatusConstants(true, 'yes', '是')
export const NO = new RadioStatusConstants(false, 'no', '否')
export const CONFIRM = new RadioStatusConstants(true, 'yes', '是')
export const NO_CONFIRM = new RadioStatusConstants(false, 'no', '否')
export const NO_COMMITTED = new RadioStatusConstants(false, 'no_committed', '未提交')
export const COMMITTED = new RadioStatusConstants(true, 'committed', '提交')
export const NO_WRITTENBACK = new RadioStatusConstants(false, 'committed', '未红冲')
export const WRITEBACK = new RadioStatusConstants(true, 'committed', '红冲')

export const CONFIRMED_TYPES = [CONFIRMED, NO_CONFIRMED]
export const SHOW_TYPES = [SHOW, NO_SHOW]
export const YES_NO_TYPES = [YES, NO]
export const CONFIRM_TYPES = [CONFIRM, NO_CONFIRM]
export const COMMIT_TYPES = [COMMITTED, NO_COMMITTED]
export const WRITEBACK_TYPES = [NO_WRITTENBACK, WRITEBACK]
